<template>
    <a
        :href="href"
        :class="['media-card', isVertical ? 'media-card__vertical':'']"
    >
        <article class="media-card__container">

            <div
                class="media-card__image"
                role="img"
                :alt="label"
            ></div>

            <div v-if="showContent" class="media-card__content">
                <div class="row u-flex-col u-justify-between u-collapse--all u-entire-height">
                    <z-caption class="media-card__content-title u-collapse--all">
                        {{ label }}
                    </z-caption>

                    <p v-if="formatedDate" class="u-collapse--all text-size-m white-text">
                        {{ formatedDate }}
                    </p>
                </div>

                <div v-if="showButton">
                    <z-button
                        :only-icon=true
                        kind="bordered"
                        size="s"
                    >
                        <z-icon name="arrows/caret-light" dir="right" class="media-card__icon"></z-icon>
                    </z-button>
                </div>
            </div>
        </article>
    </a>
</template>

<script setup>
import { computed } from 'vue'
import { useFormatDate } from '../composable/useUtils';

const props = defineProps({
    image: {
        type: String
    },
    href: {
        type: String
    },
    imagesCount: {
        type: Number,
        required: false
    },
    videosCount: {
        type: Number,
        required: false
    },
    showButton: {
        type: Boolean,
        default: true
    },
    showContent: {
      type: Boolean,
      default: true,
    },
    date: Number,
    label: String,
    detail: String,
    isVertical: {
        type: Boolean,
        default: false
    }
})

const formatedDate = computed(() => useFormatDate(props.date))

const backgroundImage = computed(() => `url(${props.image})`);
</script>

<style lang="scss">
.media-card {
    $parent: &;
    position: relative;

    cursor: pointer;

    text-decoration: none;

    .z-caption {
        color: var(--color-white);
    }

    .z-date {
        span {
            color: var(--color-white);
        }
    }

    &__icons {
        position: absolute;
        padding: var(--spacer-m);
    }

    &__container {
        border-radius: 20px;
        overflow: hidden;
        min-height: 340px;
        height: 100%;
        display: flex;
        flex-direction: column;

        @include breakpoint(v-tablet) {
            min-height: 500px;
        }

        #{$parent}__image {
            aspect-ratio: 2 / 1;
            flex-grow: 1;
            background-image: v-bind(backgroundImage);
            background-size: cover;
            background-repeat: no-repeat;
        }

        #{$parent}__content {
            word-break: break-word;
            background-color: var(--color-primary);
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: var(--spacer-3xs);
            padding: var(--spacer-m) var(--spacer-l);

            &-title {
                min-height: 2.5em;
            }

            #{$parent}__icon {
                width: var(--spacer-m);
                height: var(--spacer-m);
            }
        }
    }

    &__vertical {
        min-height: 720px;
        grid-row: span 2;
    }
}
</style>
